import React from "react";
import "./CardPosts.scss";
//import ListPost from "../ListPost";

function CardPosts(props) {
  const {title, height} = props;
  return (
    <div className={`card-posts-${height}`}>
      <p className="card-posts-title">{title}</p>
      <div className="posts-list">
        {props.children}
      </div>
    </div>
  );
}

export default CardPosts;
